import React from 'react';
import { Flex, Modal, Anchor } from '@mantine/core';
import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';
import { useTranslation } from 'react-i18next';
import styles from '../ModelDetail.module.scss';

interface Paper {
  url: string;
  title?: string;
}

interface PapersModalProps {
  opened: boolean;
  onClose: () => void;
  papers?: Paper[];
}

export const PapersModal: React.FC<PapersModalProps> = ({
  opened,
  onClose,
  papers = [],
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <TextComponent variant="headerLarge">
          {t('mosaic.modelDetail.cards.details.fields.arxivePapers')}
        </TextComponent>
      }
      size="lg"
    >
      <Flex direction="column" gap="md">
        {papers.length === 0 && (
          <TextComponent variant="componentSmall" color="muted">
            {t('page.ai-explore.model.details.noPapers')}
          </TextComponent>
        )}

        <Flex direction="column" gap="sm">
          {papers.map((paper, index) => (
            <Flex key={index} align="center" gap="xs">
              <Anchor
                href={paper.url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.paperLink}
              >
                {paper.title || paper.url}
              </Anchor>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Modal>
  );
};
